import { useState } from 'react'

import { SIZE } from '../../../constants/size'
import Button from '../../Button'
import { TableModal } from '../../TableModal'
import { EmailVariablesReportTableRow } from '../EmailVariablesReportTableRow'

import {
  QA_NAME_VARIABLES_MODAL,
  REPORT_COLUMNS,
  REPORT_PAGE_SIZE,
} from './EmailVariablesReportModal.constants'

function EmailVariablesReportModal({ recipients, onClose }) {
  const [pagination, setPagination] = useState({
    count: recipients.length,
    page: 1,
    pageCount: Math.ceil(recipients.length / REPORT_PAGE_SIZE),
    pageSize: REPORT_PAGE_SIZE,
  })

  const data = recipients.slice(
    REPORT_PAGE_SIZE * (pagination.page - 1),
    REPORT_PAGE_SIZE * pagination.page
  )

  return (
    <TableModal
      Search={null}
      actionsProps={{
        ButtonAttach: null,
        buttonCancelProps: {
          Component: Button.Contained,
          text: 'Modal.OkBtnKey',
          onClick: onClose,
        },
      }}
      headerProps={{
        text: 'Email.EmailVariablesReportTitleKey',
        onClose,
      }}
      isFullScreenExist={false}
      paginationProps={{ pagination, onChange: setPagination }}
      qaName={QA_NAME_VARIABLES_MODAL}
      size={SIZE.LARGE}
      tableItems={data}
      tableProps={{
        TableRow: EmailVariablesReportTableRow,
        actionsColumnWidth: null,
        columns: REPORT_COLUMNS,
        headerRowProps: {
          resizable: false,
        },
        items: data,
      }}
      onClose={onClose}
      onTableModalClose={onClose}
    />
  )
}

export default EmailVariablesReportModal
